<template>
  <div
    class="detail-popup"
    :style="{
      'left': `${left}px`,
      'top': `${top}px`,
    }"
  >
    <div class="detail-popup__thumbnail">
      <a
        class="detail-popup__thumbnail-anchor"
        :class="{'detail-popup__thumbnail-anchor--has-video': item.videoUrl}  "
        @click="$emit('click:video', item)"
      >
        <img
          :src="`${imagesHost}${item.thumbnailImage}`"
          class="detail-popup__thumbnail-image"
          alt=""
        >
        <img
          v-if="item.videoUrl"
          src="~@/assets/img/icon_video.png"
          class="detail-popup__thumbnail-icon-video"
          alt=""
        >
        <span class="detail-popup__vertical-icon">
          <img
            v-if="item.vertical === 'Corporate'"
            src="~@/assets/img/icon_corporate.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Education'"
            src="~@/assets/img/icon_education.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'General'"
            src="~@/assets/img/icon_general.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Government'"
            src="~@/assets/img/icon_government.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Hospitality'"
            src="~@/assets/img/icon_hospitality.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Public Space'"
            src="~@/assets/img/icon_public-space.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Retail'"
            src="~@/assets/img/icon_retail.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
          <img
            v-if="item.vertical === 'Transportation'"
            src="~@/assets/img/icon_transportation.png"
            alt=""
            class="detail-popup__vertical-icon-image"
          >
        </span>
      </a>
    </div>
    <div class="detail-popup__content">
      <div class="detail-popup__vertical">
        {{ item.vertical }}
      </div>
      
      <div class="detail-popup__title">
        {{ item.title }}
      </div>
      <a
        class="detail-popup__anchor-detail"
        @click="handleClickDetailLink(item.detailLink, item.title)"
      >View Detail ></a>
      <template v-if="item.recommendedProduct.length">
        <div class="detail-popup__hr" />
        <div class="detail-popup__subtitle">
          Recommended Products
        </div>
        <div class="detail-popup__recommended">
          <carousel
            :per-page="3"
            :mouse-drag="true"
            :navigation-enabled="true"
            :pagination-enabled="false"
            class="detail-popup__recommended-list"
          >
            <slide
              v-for="(product, index) in item.recommendedProduct.filter(p => p.isActive === 'ACTIVE')"
              :key="`popup__recommended-${index}`"
              class="detail-popup__recommended-item"
            >
              <a
                class="detail-popup__recommended-anchor"
                @click="handleClickProductDetailLink(product.detailLink, product.prodThumb, product.modelName, product.productCategory1, product.productCategory2, product.productCategory3)"
              >
                <img
                  :src="`${imagesHost}${product.prodThumb}`"
                  class="detail-popup__recommended-thumbnail"
                >
                <div class="detail-popup__recommended-product">{{ product.modelSeries }}</div>
                <div class="detail-popup__recommended-modelname">{{ product.modelName }}</div>
              </a>
            </slide>
          </carousel>
        </div>
      </template>
      <div class="detail-popup__software">
        <a
          v-if="item.solutionTitle1"
          :href="item.solutionLink1"
          class="detail-popup__software-anchor"
          target="_blank"
        >
          {{ item.solutionTitle1 }}
          <span><img
            src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
            alt=""
          ></span>
        </a>
        <a
          v-if="item.solutionTitle2"
          :href="item.solutionLink2"
          class="detail-popup__software-anchor"
          target="_blank"
        >
          {{ item.solutionTitle2 }}
          <span><img
            src="/theme/rbFront/img/w/case-study/mobile/arrow_right.png"
            alt=""
          ></span>
        </a>
      </div>
    </div>
    <button
      type="button"
      class="detail-popup__close-button"
      @click="$emit('click:close')"
    >
      <img
        src="~@/assets/img/button_close.png"
        class="detail-popup__close-button-image"
        alt=""
      >
    </button>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'DetailPopup',
  components: {
    Carousel,
    Slide
  },
  props: {
    left: {
      type: Number,
      requried: false,
      default: 0
    },
    top: {
      type: Number,
      requried: false,
      default: 0
    },
    item: {
      type: Object,
      required: true,
    }
  },
  computed: {
    imagesHost() {
      if (window.location.host.indexOf('www.') > -1) {
        return 'https://image.lgcommercialdisplay.com'
      } else {
        return 'https://stg.lgcommercialdisplay.com'
      }
    }
  },
  methods: {
    handleClickDetailLink(url, text) {
      window.dataLayer.push({
        event: 'select_story',
        click_text: text, 
        click_url: url
      });
      window.open(url, '_blank')
    },
    handleClickProductDetailLink(url, img, name, category1, category2, category3) {
      window.dataLayer.push({
        event: 'select_product',
        click_text: 'View Detail',
        click_url: url,
        img_url: img,
        img_alt: '',
        product_name: name,
        product_category1: category1,
        product_category2: category2,
        product_category3: category3
      });
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
$detail-popup: '.detail-popup';
#{$detail-popup} {
  position: absolute;
  left: 0;
  top: 0;
  width: 386px;
  box-shadow: 0px 2px 9.6px 0.4px rgba(0, 0, 0, 0.15);
  
  &__thumbnail {
    position: relative;
    height: 216px;
  }
  &__thumbnail-anchor {
    display: block;
    width: 100%;
    height: 100%;
    background-color: #d4d4d4;
    &--has-video:hover {
      cursor: pointer;
    }
  }
  &__thumbnail-image {
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
  &__thumbnail-icon-video {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  &__vertical-icon {
    display: block;
    width: 54px;
    height: 50px;
    position: absolute;
    right: 0;
    bottom: -2px;
    background-color: #fff;
  }
  &__vertical-icon-image {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    height: 100%;
  }
  &__content {
    background-color: #fff;
    padding: 15px 28px 25px;
    overflow: hidden;
    border-radius: 3px;
  }
  &__vertical {
    font-size: 18px;
    line-height: 18px;
    color: #221815;
    margin-bottom: 8px;
  }
  &__title {
    font-size: 24px;
    line-height: 26px;
    color: #221815;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  &__anchor-detail {
    height: 30px;
    display: block;
    text-align: center;
    line-height: 30px;
    border: solid 1px #000 ;
    border-radius: 22px;
    color: #000 ;
    margin-top: 18px;
    cursor: pointer;
  }
  &__hr {
    height: 1px;
    background-color: #b3b3b3;
    margin: 15px 0 10px;
  }
  &__subtitle {
    font-size: 15px;
    line-height: 15px;
    color: #221815;
    margin-bottom: 10px;
  }
  &__recommended-item {
    flex-basis: 105px;
    height: 112px;
    border: solid 1px #2d2d2d;
    border-radius: 4px;
    padding: 8px 8px 15px;
    box-sizing: border-box;
    margin-left: 6px;
  }
  &__recommended-item:first-child {
    margin-left: 0;
  }
  &__recommended-anchor {
    display: block;
    text-align: center;
    cursor: pointer;
  }
  &__recommended-thumbnail {
    // width: 80px;
    max-width: 80px;
    height: 46px;
  }
  &__recommended-product {
    font-size: 11px;
    line-height: 11px;
    color: #221815;
    margin-bottom: 6px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: 87px;
  }
  &__recommended-modelname {
    font-size: 18px;
    line-height: 18px;
    color: #221815;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
    width: 87px;
  }
  &__close-button {
    position: absolute;
    right: -22px;
    top: -22px;
  }
  &__software {
    margin-top: 10px;
    font-size: 18px;
  }
  &__software-anchor {
    position: relative;
    display: block;
    height: 34px;
    line-height: 36px;
    border: solid 1px #000;
    border-radius: 3px;
    padding: 0 8px;
    margin-top: 8px;
    span {
      position: absolute;
      display: block;
      width: 18px;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      img {
        max-width: 100%;
      }
    }
  }
  /deep/ .VueCarousel-navigation-prev {
    padding: 0!important;
    margin: 0!important;
    width: 8px;
    height: 13px;
    left: -10px;
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 0 no-repeat;
    background-size: 8px auto;
  }
  /deep/ .VueCarousel-navigation-next {
    padding: 0!important;
    margin: 0!important;
    width: 8px;
    height: 13px;
    right: -10px;
    text-indent: -9999px;
    background: url(~@/assets/img/icon_prevafter15x25.png) 0 100% no-repeat;
    background-size: 8px auto;
  }
}


</style>
